import React from 'react';
import { Steps, Form, Input, Divider, message } from 'antd';
import { connect } from 'react-redux';
import 'antd/dist/antd.css';
import request from '../../scripts/request';

const { Search } = Input;
const InputGroup = Input.Group;
const { Step } = Steps;
let $this;
class InitPage extends React.Component {
    constructor(props) {
        super(props);
        $this=this;
    }
    componentDidMount() {

    }

    //通过注册码获取用户信息
    userSearchHandl = (value) => {
        if (value !== '') {
            request({
                url: 'api/DataInit/userMsgLoad',
                method: 'post',
                data: { zcm: value }
            }).then(function (res) {
                if (res !== null) {
                    const { ZcmSubmit } = $this.props;
                    ZcmSubmit(res.data);
                }
            });
        }
        else {
            message.info('请输入有效的注册码');
        }
    }

    render() {
        let store=this.props.store;
        return (
            <div style={{ width: '100%' }}>
                <Form layout="inline">
                    <Form.Item >
                        <Search
                            placeholder="请输入注册码进行初始化"
                            onSearch={this.userSearchHandl}
                            enterButton
                            autoFocus
                            name="zcm"
                            style={{ width: '470px' }}
                        />
                    </Form.Item>
                    <Form.Item>
                        <InputGroup compact style={{width:'470px'}}>
                            <Input style={{ width: '60%' }} value={store.PageInit.dwmc} name="dwmc" placeholder="注册机构名称" />
                            <Input style={{ width: '40%' }} value={store.PageInit.yhmc} name="yhmc" placeholder="区域名称" />
                        </InputGroup>
                    </Form.Item>
                </Form>
                <Divider />
                <Steps direction="vertical" current={store.PageInit.current} status={store.PageInit.status}>
                    <Step title="系统字典初始化" description={store.PageInit.description1} />
                    <Step title="用户信息初始化" description={store.PageInit.description2} />
                    <Step title="初始化完成" description={store.PageInit.description3} />
                </Steps>
            </div>
        );
    }
}
//需要渲染什么数据
function mapStateToProps(state) {
    return {
        store: state
    }
}
//需要触发什么行为
function mapDispatchToProps(dispatch) {
    return {
        ZcmSubmit: (data) => dispatch(
            {
                type: 'ZcmSubmit', data:data//注册码提交
            }
        )
    }
}
//连接组件
InitPage = connect(mapStateToProps, mapDispatchToProps)(InitPage)
export default InitPage;